import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Pattes = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.97 82.97">
  <G fill={color}>
    <Path d="M50.16,22.92c-1.52-4.04-5.36-7.09-9.38-7.1-4.04-.01-7.91,2.66-9.38,6.78-.78,2.18-1.98,3.9-3.72,5.4-3.62,3.13-2.74,7.91,1.69,9.74,2.83,1.17,5.58.92,8.24-.5,2.03-1.08,4-1.06,6.05-.02,1.01.51,2.11.9,3.21,1.13,3.32.69,7.07-.96,8.41-3.6,1.31-2.58.52-4.61-2.46-7.59-1.16-1.16-2.09-2.7-2.67-4.23Z"/>
    <Path d="M24.87,20.29c2.48-.03,4.39-1.96,4.41-4.96-.07-1.73-.84-3.65-2.36-5.23-1.33-1.38-2.83-1.39-4.18-.03-1.55,1.56-2.34,3.5-2.41,5.68-.08,2.53,2.02,4.57,4.54,4.54Z"/>
    <Path d="M58.64,10.22c-1.17-1.64-3.16-1.64-4.34.01-1.02,1.44-1.78,3.17-2.21,4.88-.63,2.48,1.42,4.94,3.96,5.16,2.67.23,4.92-1.84,4.91-4.51.15-.08-1.17-3.93-2.32-5.54Z"/>
    <Path d="M47.51,11.31c2.44-.03,4.41-2.04,4.43-4.95-.06-1.75-.83-3.67-2.35-5.26-1.37-1.42-2.79-1.44-4.17-.06-1.56,1.56-2.35,3.5-2.44,5.67-.1,2.49,2.07,4.62,4.53,4.59Z"/>
    <Path d="M33.48,11.3c2.51.25,4.8-1.88,4.8-4.46,0-1.95-1-4.44-2.32-5.73-1.46-1.43-3.09-1.56-4.26.07-1.06,1.48-1.86,3.25-2.31,5.02-.62,2.44,1.47,4.84,4.08,5.09Z"/>
    <Path d="M29.84,67.38c-1.52-4.04-5.36-7.09-9.38-7.1-4.04-.01-7.91,2.66-9.38,6.78-.78,2.18-1.98,3.9-3.72,5.4-3.62,3.13-2.74,7.91,1.69,9.74,2.83,1.17,5.58.92,8.24-.5,2.03-1.08,4-1.06,6.05-.02,1.01.51,2.11.9,3.21,1.13,3.32.69,7.07-.96,8.41-3.6,1.31-2.58.52-4.61-2.46-7.59-1.16-1.16-2.09-2.7-2.67-4.23Z"/>
    <Path d="M8.95,59.79c-.07-1.73-.84-3.65-2.36-5.23-1.33-1.38-2.83-1.39-4.18-.03C.87,56.09.07,58.03,0,60.21c-.08,2.53,2.02,4.57,4.54,4.54,2.48-.03,4.39-1.96,4.41-4.96Z"/>
    <Path d="M33.98,54.7c-1.02,1.44-1.78,3.17-2.21,4.88-.63,2.48,1.42,4.94,3.96,5.16,2.67.23,4.92-1.84,4.91-4.51.15-.08-1.17-3.93-2.32-5.54-1.17-1.64-3.16-1.64-4.34.01Z"/>
    <Path d="M27.19,55.77c2.44-.03,4.41-2.04,4.43-4.95-.06-1.75-.83-3.67-2.35-5.26-1.37-1.42-2.79-1.44-4.17-.06-1.56,1.56-2.35,3.5-2.44,5.67-.1,2.49,2.07,4.62,4.53,4.59Z"/>
    <Path d="M13.16,55.76c2.51.25,4.8-1.88,4.8-4.46,0-1.95-1-4.44-2.32-5.73-1.46-1.43-3.09-1.56-4.26.07-1.06,1.48-1.86,3.25-2.31,5.02-.62,2.44,1.47,4.84,4.08,5.09Z"/>
  </G>
</Svg>
);
};

export default Pattes;
